var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "w-100" }, [
    _c("div", { staticClass: "styles-result-header" }, [
      _vm._v(
        "\n    " +
          _vm._s(_vm.$resourceString["site.search.styles.result.header"]) +
          "\n  "
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row w-100" },
      [
        _vm._l(_vm.safeProducts.slice(0, 4), function(item) {
          return _c("div", { key: item.styleNumber, staticClass: "col-2" }, [
            _c("div", { staticClass: "d-block" }, [
              _c(
                "a",
                {
                  staticClass: "text-decoration-none",
                  attrs: {
                    href: _vm.$helpers.getProductDetailUrl(
                      item.styleNameURL,
                      item.styleNumber,
                      item.colors[0].colorNumber
                    )
                  }
                },
                [
                  _c("wf-load-image", {
                    attrs: {
                      wrapperClass: "w-100 styles-image",
                      imageClass: "image w-100",
                      src: item.colors[0].imagePath,
                      alt: item.styleName,
                      noImageStyles: "no-image-style-block"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("ul", { staticClass: "styles-list" }, [
              _c("li", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$helpers.matchText(item.styleName, _vm.searchTerm)
                  )
                }
              }),
              _vm._v(" "),
              _c("li", [_vm._v(_vm._s(item.productActualSize) + " ")]),
              _vm._v(" "),
              item.colors[0].colorName && item.colors[0].colorNumber
                ? _c("li", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$helpers.matchText(
                          item.colors[0].colorName +
                            " - " +
                            item.colors[0].colorNumber,
                          _vm.searchTerm
                        )
                      )
                    }
                  })
                : _c("li", [
                    _vm._v(
                      "\n          " +
                        _vm._s(item.itemsCount) +
                        "\n          " +
                        _vm._s(
                          _vm.$resourceString[
                            "site.search.products.result.color.list"
                          ]
                        ) +
                        "\n        "
                    )
                  ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-auto" },
              [
                _c(
                  "a",
                  {
                    staticClass: "view-styles-link cart-item-model-no",
                    attrs: {
                      href: _vm.$helpers.getProductDetailUrl(
                        item.styleNameURL,
                        item.styleNumber,
                        item.colors[0].colorNumber
                      )
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$resourceString[
                          "site.search.products.result.view.style"
                        ]
                      )
                    )
                  ]
                ),
                _vm._v(" "),
                _c("Icon", {
                  staticClass: "mb-1",
                  attrs: { icon: "bx:bx-right-arrow-alt", width: "15" }
                })
              ],
              1
            )
          ])
        }),
        _vm._v(" "),
        _c("div", { staticClass: "col-2 " }, [
          _vm.products.length > 4
            ? _c(
                "a",
                {
                  attrs: {
                    href: _vm.$helpers.getSearchTermUrl(
                      _vm.searchTerm,
                      "styles"
                    )
                  }
                },
                [
                  _c("div", { staticClass: "view-more" }, [
                    _c(
                      "div",
                      { staticClass: "view-more-text" },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$resourceString[
                                "site.search.products.result.view.more"
                              ]
                            ) +
                            "\n            "
                        ),
                        _c("Icon", {
                          staticClass: "pb-1 pl-1",
                          attrs: {
                            icon: "fa-solid:plus",
                            color: "white",
                            width: "20"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]
              )
            : _vm._e()
        ])
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }